<template>
  <div>
  <div v-if="canInvite()">
    <b-button :pressed.sync="cutterCollapsed" variant=default size="sm" class="float-right">
    <i :class="!cutterCollapsed?'bi bi-chevron-up':'bi bi-chevron-down'"></i>
    </b-button>

  <b-collapse id="editor-table-collaspe" :visible="cutterCollapsed">
    <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-6">
          <b-button @click="selectAll()" variant="outline-primary" pill size="sm">alle auswählen</b-button>
          <b-button @click="selectNone()" variant="outline-primary" pill size="sm">alle abwählen</b-button>
          <b-button @click="toggle()" variant="outline-primary" pill size="sm">wechseln</b-button>
          <b-button @click="selectMitglied()" variant="outline-primary" pill size="sm">alle Mitglieder</b-button>
        </div>
        <div class="col-6">
          <b-form-select v-model="selectedStandort" @change="emitStandortSelection" size="sm" >
            <b-form-select-option value="0"><i>Alle</i></b-form-select-option>
              <b-form-select-option v-for="(stdo,sidx) in standortList" v-bind:key="sidx" :value="stdo.id">{{stdo.name}}</b-form-select-option>
          </b-form-select>
        </div>
      </div>
    </div>
    <div v-for="(cutter, idx) in einzuladendeCutter" :key="idx" class="col-sm-12 col-md-6 col-lg-4">
      <b-form-checkbox v-model="selectedCutters[cutter.id]">{{cutter.name}}&nbsp;<router-link :to="'/Benutzer/'+cutter.id"><i class="bi bi-info-circle"></i></router-link>
      </b-form-checkbox>
    </div>
  </div>
  </b-collapse>
  </div>
  <div class="CutterAngebotTable">
  <div class="table-responsive">

<div class="mt-3"  v-if="zugesagt().length===0 && auftrag.angebote && auftrag.angebote.length>0">
 <AngebotOverview ref="AngebotOverview" :angebote="auftrag.angebote" @refresh-list="refresh"/>
</div>
    <b-table
     v-if="zugesagt () && zugesagt ().length>0"
     responsive="true"
     striped
     hover
     id="user-table"
     :items="zugesagt ()"
     :fields="fields">

     <template #cell(Name)="data">
    <span :class="textColor(data.item)">
     {{findCutter(data.item.cutterId).name}}
     </span><br/>
     <a class="btn btn-sm" @click="sendEMail(data.item.cutterId)"><i class="bi bi-envelope"></i></a>
     <router-link :to="'/Benutzer/'+data.item.cutterId"><i class="bi bi-info-circle"></i></router-link>
    </template>
     <template #cell(Nachricht)="data">
    <span :class="textColor(data.item)">
     {{data.item.nachricht}}
    </span>
    </template>
    <template #cell(Format)="data">
    <span :class="textColor(data.item)">
    {{auftrag.format.name}}:
     {{findFormat(data.item.cutterId, auftrag.formatId).erfahrung}}
    </span>
    </template>
    <template #cell(VermittelteGagen)="data">
    <span :class="textColor(data.item)">
     {{cutterGagen(data.item.cutterId).toLocaleString('de-DE')}} €
     </span>
    </template>
    <template #cell(Zuletzt)="data">
     {{findCutter(data.item.cutterId).__last|formatDateOnly}}
    </template>
    <template #cell(Aktion)="data">
    <div v-if="data.item.auftragAngebotStatus==='Angenommen'">
     <b-button v-if="data.item.cutterId!==auftrag.cutterId && !auftrag.cutterId" variant="primary" size="sm" @click="action({name:'AuftragBestaetigen',type:'Confirm'}, data.item.auftragId, {'cutterId':data.item.cutterId})">
          Cutter zuweisen
     </b-button>
      <span v-if="data.item.cutterId!==auftrag.cutterId" variant="primary" size="sm" @click="action({name:'AnfrageZuruecksetzen',type:'Confirm'}, data.item.auftragId, {'cutterId':data.item.cutterId})">
         <i class="bi bi-x-circle"></i>
     </span>
     <div v-if="data.item.cutterId===auftrag.cutterId">
     <span  class="text-success">
      <strong>Zugewiesen</strong>
       </span>
     <span v-if="auftrag.auftragStatus=='Bestaetigt'" class="text-danger" @click="action({name:'AuftragEntziehen',type:'Confirm'}, data.item.auftragId, {})">
       <i class="bi bi-x-circle"></i>
     </span>
     </div>
     </div>
    </template>
     </b-table>
    <div> &nbsp;
    <b-button :pressed.sync="ausstehendCollapsed" variant=default size="sm" class="float-right">
    <i :class="!ausstehendCollapsed?'bi bi-chevron-up':'bi bi-chevron-down'"></i>
    </b-button>
    </div>
    <b-collapse id="ausstehende-collaspe" :visible="ausstehendCollapsed">
    <div v-if="ausstehendeCutter()!=''" class="col-12 p-0">
    Ausstehend:
    <span class="text-muted">{{ausstehendeCutter()}}</span>
    </div>
    </b-collapse>
  </div>
  </div>
  </div>
</template>
<script>
import api from '@/api/workflow'
import afunc from '@/functions'
import utils from '@/utilities'
import AngebotOverview from '@/components/partials/AngebotOverview'

export default {
  name: 'CutterAngebotTable',
  components: {AngebotOverview},
  props: ['angebote', 'cutters', 'einzuladendeCutter', 'selectedCutters', 'auftrag'],
  watch: {
    auftrag: function (nAuftrag, oAuftrag) {
      if (nAuftrag && nAuftrag.angebote) {
        this.cutterCollapsed = (nAuftrag.angebote.length === 0)
        this.selectedStandort = this.findStandortId(this.auftrag.standortFormular)
      }
    }
  },
  methods: {
    async sendEMail (benutzerId) {
      let message = prompt('Welche Nachricht wollen Sie senden?')
      if (message) {
        let form = new FormData()
        form.append('message', message)
        form.append('userId', benutzerId)
        let result = await api.action('QuickMail', this.auftrag.id, form)
        if (!result['errorMessage']) {
          utils.makeToast(this, 'Erfolgreich ausgeführt!', 'success')
        } else {
          utils.makeToast(this, result['errorMessage'], 'danger')
        }
      }
    },
    ausstehendeCutter () {
      let result = ' '
      if (this.auftrag && this.auftrag.angebote) {
        for (let aa of this.auftrag.angebote) {
          result += (aa.auftragAngebotStatus !== 'Angenommen' ? this.cutterName(aa.cutterId) + ', ' : '')
        }
      }
      return result.substr(0, result.length - 2)
    },
    canInvite () {
      if (this.auftrag.__actions) {
        for (let action of this.auftrag.__actions) {
          if (action.name === 'Disponieren') {
            return true
          }
        }
      }
      return false
    },
    selectAll () {
      this.$bubble('select-all-cutters')
    },
    selectNone () {
      this.$bubble('deselect-all-cutters')
    },
    toggle () {
      this.$bubble('toggle-all-cutters')
    },
    selectMitglied () {
      this.$bubble('select-all-mitglied')
    },
    emitStandortSelection () {
      this.$bubble('standort-selection-changed', this.selectedStandort)
    },
    textColor (item) {
      if (item.auftragAngebotStatus !== 'Angenommen') {
        return 'text-muted'
      }
      return ''
    },
    cutterName (cutterId) {
      for (let i = 0; this.cutters && i < this.cutters.length; i++) {
        if (this.cutters[i].id === cutterId) {
          return this.cutters[i].name
        }
      }
      return 'Editor #' + cutterId + ' (Name nicht verfügbar)'
    },
    zugesagt () {
      let result = []
      if (this.angebote) {
        for (let i = 0; i < this.angebote.length; i++) {
          if (this.angebote[i].auftragAngebotStatus === 'Angenommen') {
            result.push(this.angebote[i])
          }
        }
      }
      return result
    },
    async action (action, id, data) {
      let form = new FormData()
      for (const [key, value] of Object.entries(data)) {
        form.append(key, value)
      }
      let result = await afunc.actionFunc(this, api, action, id, form)
      if (!result['errorMessage']) {
        utils.makeToast(this, 'Erfolgreich ausgeführt!', 'success')
      } else {
        utils.makeToast(this, result['errorMessage'], 'danger')
      }
    },
    findFormat (cutterId, formatId) {
      let cutter = this.findCutter(cutterId)
      if (cutter.formate) {
        for (let i = 0; i < cutter.formate.length; i++) {
          if (cutter.formate[i].id.formatId === formatId) {
            return cutter.formate[i]
          }
        }
      }
      return {'erfahrung': '-'}
    },
    refresh () {
      this.$bubble('refresh-view')
    },
    findStandortId (standort) {
      for (let i = 0; i < this.$store.state.auth.baseData.standorte.length; i++) {
        if (this.$store.state.auth.baseData.standorte[i].name === standort) {
          return this.$store.state.auth.baseData.standorte[i].id
        }
      }
      return 0
    },
    cutterGagen (id) {
      if (id) {
        let cutter = this.findCutter(id)
        return (cutter.gageOffset || 0) + (cutter.gagen || 0)
      }
      return 0
    },
    findCutter (id) {
      for (let i = 0; this.cutters && i < this.cutters.length; i++) {
        if (this.cutters[i].id === id) {
          return this.cutters[i]
        }
      }
      return {}
    }
  },
  data () {
    return {
      ausstehendCollapsed: false,
      cutterCollapsed: true,
      selectedStandort: 0,
      standortList: this.$store.state.auth.baseData.standorte,
      fields: ['Name', 'Nachricht', 'Format', 'VermittelteGagen', 'Zuletzt', 'Aktion']
    }
  }
}
</script>
<style scoped>
.btn:focus {
  outline: none;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/main/vue/components/partials/CutterAngebotTable.vue